export enum DashboardWidgetTypes {
  AttributeChart = 'attribute-chart',
  AttributeCategory = 'attribute-category',
  Grid = 'grid',
  Kpi = 'kpi',
  Text = 'text',
}
